export default __webpack_public_path__ + "static/media/861.ee4fde35.jpg";